module.exports = __webpack_public_path__ + "img/5.60a94b92.jpg";